import NotImplementedError from 'services/errors/NotImplementedError';

export default class AbstractService {

    getReducer() {
        throw new NotImplementedError();
    }

    getInitialState() {
        throw new NotImplementedError();
    }

    getStoreKey() {
        throw new NotImplementedError();
    }

    getMyState(storeState) {
        if (!storeState) {
            storeState = this.getStore().getState();
        }
        return storeState[this.getStoreKey()];
    }

    dispatch(action) {
        return window.PCM.store.dispatch(action);
    }

    getStore() {
        return window.PCM.store;
    }

}



// WEBPACK FOOTER //
// ./src/services/AbstractService.js